// 앱 안 링크로 떠날 때 물을지 — 잠긴 뒤의 편집만 묻는다(그 밖엔 언마운트 자동저장이 서버 초안·pending 으로 남겨 돌아오면 이어 쓴다).
export const leaveNeedsConfirm = (s: { dirty: boolean; locked: boolean }): boolean => s.dirty && s.locked;

export const LOCKED_LEAVE_CONFIRM = "이 편집은 저장되지 않고 이 화면에만 있습니다 — 「편집 내용 복사」 없이 나가면 사라집니다. 그대로 나갈까요?";

export { LEAVE_PASS_MS, leavesInApp, unloadPassed } from "../../../lib/leave-guard";
export type { LinkClick, LinkTarget } from "../../../lib/leave-guard";
